import React from 'react';
import { ShieldCheck, CreditCard, Building2, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';
import { mockData } from '../mock';

const iconMap = {
  'shield-check': ShieldCheck,
  'credit-card': CreditCard,
  'building-2': Building2
};

const Services = () => {
  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-black">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl font-bold text-white">
            Our Transportation Services
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Flexible transportation solutions designed to meet your specific needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockData.services.map((service) => {
            const IconComponent = iconMap[service.icon];
            
            return (
              <Card 
                key={service.id} 
                className="border-2 border-gray-800 hover:border-cyan-500 hover:shadow-xl transition-all duration-300 bg-gray-900"
              >
                <CardHeader className="space-y-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-cyan-500/20 to-purple-600/20 rounded-xl flex items-center justify-center">
                    <IconComponent className="w-7 h-7 text-cyan-400" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-white">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-base text-gray-300 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>

                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start space-x-2">
                        <ArrowRight className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-300">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>

                <CardFooter>
                  <Button 
                    className="w-full bg-gradient-to-r from-cyan-500 to-purple-600 hover:from-cyan-600 hover:to-purple-700 text-white"
                    onClick={() => {
                      // Scroll to contact form
                      document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
                      
                      // Pre-select service type after scrolling
                      setTimeout(() => {
                        const serviceTypeButton = document.querySelector('[role="combobox"]');
                        if (serviceTypeButton) {
                          serviceTypeButton.click();
                          setTimeout(() => {
                            const serviceOption = Array.from(document.querySelectorAll('[role="option"]'))
                              .find(el => el.textContent.toLowerCase().includes(service.title.toLowerCase().split(' ')[0]));
                            if (serviceOption) serviceOption.click();
                          }, 100);
                        }
                      }, 1000);
                    }}
                  >
                    {service.cta}
                  </Button>
                </CardFooter>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
